var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-personal-skeleton-order"},_vm._l((6),function(item){return _c('div',{key:item,staticClass:"the-personal-skeleton-order__item the-personal-skeleton"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }